import template from './chargecode-details.html';
import controller from './chargecode-details.controller';

let chargecodeDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default chargecodeDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/chargecode-details/chargecode-details.component.js